import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {EventRegistrationCode} from 'shared/classes/event-registration-code';
import {Company} from 'shared/models/target-groups/company';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import {EventRegistrationRepository} from '../repositories/event-registration.repository';

@Injectable()
export class EventRegistrationService {

  constructor(private eventRegistrationRepository: EventRegistrationRepository) { }

  public getAllCodes(): Observable<Array<EventRegistrationCode>> {
    return this.eventRegistrationRepository.getAllCodes();
  }

  public getAllCompanies(): Observable<Array<Company>> {
    return this.eventRegistrationRepository.getAllCompanies();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.eventRegistrationRepository.getAllTargetGroups();
  }

  public createCode(newCode: EventRegistrationCode): Observable<EventRegistrationCode> {
    return this.eventRegistrationRepository.createCode(newCode);
  }

  public invalidateCode(code: string): Observable<void> {
    return this.eventRegistrationRepository.invalidateCode(code);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/event-registration/services/event-registration.service.ts